/*
  CLAIRENCE : fiche produit.
  0. Mention "ou 3 x ... sans frais" en tout petit a cote du prix (recalculee quand le prix change : coloris, configuration).
  1. Un avis client pres du bouton d'achat : recopie quelques avis 5 etoiles de la section "avis" (#avis) du meme produit, avec un lien "Lire tous les avis".
  2. Section des avis : 6 avis en carrousel sur mobile (4 sur ordinateur), puis un bouton "Voir plus d'avis".
     Mobile : le 1er clic passe en liste verticale (10 avis de plus), les clics suivants en ajoutent 10. Ordinateur : 4 avis de plus par clic.
  Sans section #avis (produit sans avis), seule la mention du prix est ajoutee.
*/
(function () {
  var mq = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: false };

  /* ---------- 0. Paiement en 3 fois a cote du prix ---------- */
  function setupX3() {
    var wrap = document.querySelector('.product-info__price-wrap');
    if (!wrap) return;
    var tag = document.createElement('span');
    tag.className = 'pi-x3';
    tag.style.cssText = 'font-size:.72rem;font-weight:400;letter-spacing:.01em;color:var(--cl-muted,#5A7268);white-space:nowrap;align-self:center';
    var busy = false;
    function priceEl() {
      return wrap.querySelector('.product-info__price--sale') ||
        wrap.querySelector('.product-info__price:not(.product-info__price--compare)');
    }
    function update() {
      if (busy) return;
      var p = priceEl();
      if (!p) return;
      var n = parseFloat(p.textContent.replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.'));
      if (!n || n < 30) { tag.hidden = true; return; }
      var txt = 'ou 3 × ' + (n / 3).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' € sans frais';
      busy = true;
      if (tag.textContent !== txt) tag.textContent = txt;
      tag.hidden = false;
      if (tag.previousElementSibling !== p) p.insertAdjacentElement('afterend', tag);
      busy = false;
    }
    update();
    if (window.MutationObserver) new MutationObserver(update).observe(wrap, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- 1. Un avis pres du bouton ---------- */
  /* Carte 5 etoiles : au moins 5 symboles etoile pleins dans .avis-card-stars (le span .star-empty est present sur toutes les cartes). */
  function fiveStars(card) {
    var s = card.querySelector('.avis-card-stars');
    return !!s && (s.textContent.match(/★/g) || []).length >= 5;
  }
  function buildTopReview(section) {
    var box = document.getElementById('PiReview');
    if (!box || box.childNodes.length) return;
    var cards = [].slice.call(section.querySelectorAll('.avis-card'));
    var good = cards.filter(function (c) {
      if (!fiveStars(c)) return false;
      var b = c.querySelector('.avis-card-body');
      var len = b ? b.textContent.trim().length : 0;
      return len >= 50 && len <= 260;
    }).slice(0, 5);
    if (!good.length) return;

    var track = document.createElement('div');
    track.className = 'pi-review__track';
    good.forEach(function (c) {
      var k = c.cloneNode(true);
      var ph = k.querySelector('.avis-card-photo');
      if (ph) ph.remove();
      k.classList.remove('is-extra');
      track.appendChild(k);
    });
    box.appendChild(track);

    /* La note et le nombre d'avis sont deja sous le titre : ici, seulement le lien. */
    var cap = document.createElement('p');
    cap.className = 'pi-review__cap';
    var a = document.createElement('a');
    a.href = '#avis';
    a.textContent = 'Lire tous les avis';
    cap.appendChild(a);
    box.appendChild(cap);
    box.hidden = false;
  }

  /* ---------- 2. Voir plus d'avis ---------- */
  function setupMore(section) {
    var grid = section.querySelector('.avis-grid');
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('.avis-card'));
    if (!cards.length) return;
    var listMode = false;
    var shown = 0;
    function base() { return mq.matches ? 4 : 6; }
    shown = base();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'avis-more';
    btn.textContent = 'Voir plus d’avis';
    grid.parentNode.insertBefore(btn, grid.nextSibling);

    function apply() {
      cards.forEach(function (c, i) { c.classList.toggle('is-extra', i >= shown); });
      grid.classList.toggle('is-list', listMode && !mq.matches);
      btn.hidden = shown >= cards.length;
    }
    btn.addEventListener('click', function () {
      if (mq.matches) {
        shown = Math.min(cards.length, shown + 4);
      } else {
        if (!listMode) { listMode = true; grid.scrollLeft = 0; }
        shown = Math.min(cards.length, shown + 10);
      }
      apply();
    });
    var onChange = function () { shown = Math.max(shown, base()); apply(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    apply();
  }

  function init() {
    setupX3();
    var section = document.getElementById('avis');
    if (!section) return;
    buildTopReview(section);
    setupMore(section);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();